import auth from "@/middleware/auth";
import admin from "@/middleware/admin";

export const countryRoutes = [
  {
    path: "/directories/country",
    name: "CountryList",
    meta: { middleware: [auth, admin] },
    component: () =>
      import(/* webpackChunkName: "country" */ "./components/List"),
  },
];
